// extracted by mini-css-extract-plugin
module.exports = {"footerOpen":"YourCart_footerOpen__PjH2l","move-up":"YourCart_move-up__V5Pjt","footerClose":"YourCart_footerClose__eh6HF","move-down":"YourCart_move-down__SaoiF"};